import { apiClient } from "@/api/api-client";
import { queryOptions } from "@tanstack/react-query";

export type UserSession = {
	id: number;
	name: string;
	ip_address?: string;
	user_agent?: string;
	created_at: string;
	last_used_at?: string;
	logged_out_at?: string;
	is_current: boolean;
	is_logged_out: boolean;
};

export type UserSessionsResponse = {
	data: UserSession[];
};

const getUserSessions = async (): Promise<UserSessionsResponse> => {
	const response = await apiClient.get<UserSessionsResponse>("/profile/sessions");
	return response.data;
};

export const userSessionsQueryOptions = queryOptions({
	queryKey: ["user-sessions"],
	queryFn: getUserSessions,
	staleTime: 1000 * 5, // 5 seconds - very short to catch termination events quickly
	refetchInterval: 1000 * 10, // Refetch every 10 seconds to catch termination events faster
});
